import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  GET_ADMIN_PROFILE,
  GET_ADMIN_PROFILE_FAILURE,
  GET_ADMIN_PROFILE_SUCCESS,
  UPDATE_ADMIN_PROFILE,
  UPDATE_ADMIN_PROFILE_FAILURE,
  UPDATE_ADMIN_PROFILE_SUCCESS,
} from '../Actiontype';

export const UpdateProfile = data => ({
  payload: data,
  type: UPDATE_ADMIN_PROFILE,
});
export const UpdateProfileSuccess = response => ({
  payload: response,
  type: UPDATE_ADMIN_PROFILE_SUCCESS,
});
export const UpdateProfileFailure = response => ({
  payload: response,
  type: UPDATE_ADMIN_PROFILE_FAILURE,
});

export const GetProfile = data => ({
  payload: data,
  type: GET_ADMIN_PROFILE,
});
export const GetProfileSuccess = response => ({
  payload: response,
  type: GET_ADMIN_PROFILE_SUCCESS,
});
export const GetProfileFailure = response => ({
  payload: response,
  type: GET_ADMIN_PROFILE_FAILURE,
});

export const ForgotPassword = data => ({
  payload: data,
  type: FORGOT_PASSWORD,
});
export const ForgotPasswordSuccess = response => ({
  payload: response,
  type: FORGOT_PASSWORD_SUCCESS,
});
export const ForgotPasswordFailure = response => ({
  payload: response,
  type: FORGOT_PASSWORD_FAILURE,
});

// export const clearStore = () => {
//   return {
//     type: CLEAR_STORE
//   };
// };
